<template>
 <v-dialog persistent v-model="showRoleModal" width="700" scrollable>
      <v-card>
        <!-- <loader v-if="showLoader"></loader> -->
        <v-card-title class="headline  lighten-2 border-bottom px-5"> 
            Chat with
            <div class="spacer"></div>
            <CButtonClose @click="closeModal"/>    
        </v-card-title>
        <v-card-text class="addbox">
          <div>
              <v-chip v-for="(list, i) in user.completed_profiles" :key="i" class="mr-3 mb-4" @click="runChat(list)">
                <span class="text-capitalize" >{{ list }}</span>
             </v-chip>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
  props: ["showRoleModal","user","initiateChatWithSelectedRole"],
  
  data() {
    return {};
  },
  methods:{
      closeModal(){
          this.$emit('close')
      },
      runChat(role){
        this.initiateChatWithSelectedRole(role,this.user)
      }
  }

};
</script>
<style lang="scss" scoped>
.v-card__title{
    font-size:0.875rem!important;
}
</style>
